import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import IconAngleLeft from '@adv-mt/mt-svg-icons/lib/AngleLeft'
import IconAngleRight from '@adv-mt/mt-svg-icons/lib/AngleRight'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {ACTIONS, ACTIONS_TRACKING_DATA} from './config.js'

const {FLAT} = atomButtonDesigns

const linkFactoryDefaultProp = ({children, ...rest}) => <a {...rest}>{children}</a>

const BASE_CLASS = 'mt-NavigationActions'

const NavigationActions = ({
  linkFactory: LinkFactory = linkFactoryDefaultProp,
  hrefNext,
  hrefPrev,
  onClickNext = () => {},
  onClickPrev = () => {}
}) => {
  const {i18n} = useContext(Context)
  const {track} = useAnalyticsTrack()

  const ACTION_HANDLERS = {
    [ACTIONS.NEXT_ACTION]: onClickNext,
    [ACTIONS.PREV_ACTION]: onClickPrev
  }

  const buttonProps = {
    color: 'primary',
    design: FLAT,
    link: true,
    linkFactory: LinkFactory,
    size: atomButtonSizes.LARGE,
    shape: atomButtonShapes.CIRCULAR
  }

  const onClickAction = ({action}) => {
    const {event} = ACTIONS_TRACKING_DATA[action]
    track({event})
    const clickAction = ACTION_HANDLERS[action]
    clickAction()
  }

  return (
    <ul className={BASE_CLASS}>
      <li>
        <AtomButton
          {...buttonProps}
          disabled={!hrefPrev}
          href={hrefPrev}
          leftIcon={<IconAngleLeft />}
          onClick={() => onClickAction({action: ACTIONS.PREV_ACTION})}
          title={i18n.t('NAVIGATION_PAGINATION_PREVIOUS')}
        />
      </li>
      <li>
        <AtomButton
          {...buttonProps}
          disabled={!hrefNext}
          href={hrefNext}
          leftIcon={<IconAngleRight />}
          onClick={() => onClickAction({action: ACTIONS.NEXT_ACTION})}
          title={i18n.t('NAVIGATION_PAGINATION_NEXT')}
        />
      </li>
    </ul>
  )
}

NavigationActions.displayName = 'NavigationActions'
NavigationActions.propTypes = {
  /** Define if action is in sticky topbar */
  isSticky: PropTypes.bool,
  /** Factory used to create navigation links */
  linkFactory: PropTypes.func,
  /**
   * URL to be added on the back link
   */
  hrefBack: PropTypes.string,
  /**
   * URL to be added on the next link
   */
  hrefNext: PropTypes.string,
  /**
   * URL to be added on the prev link
   */
  hrefPrev: PropTypes.string,
  /**
   * Callback on click Back button
   */
  onClickBack: PropTypes.func,
  /**
   * Callback on click Next button
   */
  onClickNext: PropTypes.func,
  /**
   * Callback on click Previous button
   */
  onClickPrev: PropTypes.func
}

linkFactoryDefaultProp.propTypes = {
  children: PropTypes.object
}

export {ACTIONS as navigationClickActions, ACTIONS_TRACKING_DATA as navigationActionsTrackingData}

export default NavigationActions
